export default {
  els: document.querySelectorAll('.js-reference-teaser'),
  initalized: false,
  init() {
    if (!this.els.length) return;

    // on mouse move move wrapper back to original position if mouse leaves teaser
    document.addEventListener('mousemove', (event) => {
      // if device doesn't have a cursor (is mobile touch device), bail, except for team module
      if (
        !window.matchMedia('(pointer:fine)').matches &&
        event.target.closest &&
        !event.target.closest('.module-team')
      ) {
        return;
      }

      const teaser = event.target.closest
        ? event.target.closest('.js-reference-teaser')
        : event.target.parentElement?.closest('.js-reference-teaser');
      if (teaser) {
        const wrapper = teaser.querySelector('.text-wrapper');
        const description = teaser.querySelector('.description');

        this.showText(wrapper, description.clientHeight, teaser);
      }

      if (teaser === null) {
        this.hideAll();
      }
    });

    this.els.forEach((el) => {
      if (
        !window.matchMedia('(pointer:fine)').matches &&
        !el.closest('.module-team')
      ) {
        return;
      }

      const wrapper = el.querySelector('.text-wrapper');
      const description = el.querySelector('.description');

      // on tab focus move wrapper up by the height of the hidden description
      el.addEventListener('focus', () => {
        this.showText(wrapper, description.clientHeight, el);
      });

      // on tab blur move wrapper back to original position
      el.addEventListener('blur', () => {
        this.hideText(wrapper, el);
      });
    });

    if (this.initalized) return;

    window.smr_eventbus.on('reinit_ref_tiles', () => {
      this.els = document.querySelectorAll('.js-reference-teaser');
      this.init();
    });

    this.initalized = true;
  },
  showText(wrapper, distance, el) {
    this.hideAll();

    wrapper.style.transform = `translateY(-${distance}px)`;
    wrapper.classList.add('exposed');
    el.classList.add('exposed');
  },
  hideText(wrapper, el) {
    wrapper.style.transform = 'translateY(0)';
    wrapper.classList.remove('exposed');
    el.classList.remove('exposed');
  },
  hideAll() {
    this.els.forEach((el) => {
      const wrapper = el.querySelector('.text-wrapper');
      this.hideText(wrapper, el);
    });
  },
};
